export const dsTrangthaiphaply = [
    {key:	1	, value:"Chưa đăng ký", icon:"AlertSolid" , color:"#d72d2d" },
    {key:	2	, value:"Chưa đủ điều kiện cấp giấy chứng nhận", icon:"AlertSettings"  , color:"#db6712"},
    {key:	3	, value:"Không đủ điều kiện cấp giấy chứng nhận", icon:"Blocked2Solid"  , color:"#d72d2d"},
    {key:	4	, value:"Đủ điều kiện cấp giấy chứng nhận", icon:"CompletedSolid" , color:"rgb(236, 113, 52)" },
    {key:	5	, value:"Đã cấp giấy chứng nhận" , icon:"CompletedSolid" , color:"#007B72"},
    {key:	6	, value:"Thế chấp", icon:"Bank" , color:"#1869b1" },
    {key:	7	, value:"Góp vốn", icon:"Commitments" , color:"#007B72" },
    {key:	8	, value:"Tranh chấp", icon:"Combine" , color:"#d72d2d" },
    {key:	9	, value:"Vướng quy hoạch", icon:"LogRemove" , color:"#d72d2d" },
    {key:	10, value:	"Nợ tiền sử dụng đất", icon:"Money" , color:"#d72d2d" },
    {key:	11, value:"Trạng thái khác", icon:"More" , color:"#3a3f44" },
    {key:	0	, value:"Chưa xác định", icon:"More" , color:"#3a3f44" }
]

